import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { CustomerLoanStatus, LoanData, NeedsAttentionHelper, NeedsAttentionModel, ProductCode, ProductCodeLabel, SsoAccountFacade, SsoAccountCheckoutState, IdentityVerificationAction } from "common";
import { ActionsService } from "../../../../core/actions/actions.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Entity } from "../../../entity/domain/models/entity.model";

@UntilDestroy()
@Component({
    selector: "ifm-others-financing-widget",
    templateUrl: "./others-financing-widget.component.html",
    styleUrls: ["./others-financing-widget.component.scss"],
    standalone: false
})
export class OthersFinancingWidgetComponent implements OnInit, OnChanges {
  @Input() entity: Entity;
  @Input() loans: LoanData[];
  @Input() needsAttentionModel: NeedsAttentionModel;

  loanStatus = CustomerLoanStatus;
  needsAttentionMessage: string;
  currentVerificationAction: IdentityVerificationAction;

  readonly IdentityVerificationAction = IdentityVerificationAction;

  constructor(
    private readonly actions: ActionsService,
    private readonly ssoAccountFacade: SsoAccountFacade
  ) { }

  ngOnInit(): void {
    this.initSsoAccountState();
  }

  ngOnChanges(): void {
    this.initNeedsAttentionModel();
  }

  onClickSeeAllLoans(): void {
    this.actions.seeAllLoans({ entityId: this.entity.id });
  }

  private initSsoAccountState(): void {
    this.ssoAccountFacade
      .getSsoAccountCheckoutState$()
      .pipe(untilDestroyed(this))
      .subscribe((state: SsoAccountCheckoutState) => {
        this.currentVerificationAction = state?.identityVerificationAction;
      });
  }

  onDetails(loan: LoanData): void {
    this.dispatchOtherFinancingDetails(loan, this.currentVerificationAction);
  }

  private initNeedsAttentionModel(): void {
    this.needsAttentionMessage = NeedsAttentionHelper.getNeedsAttentionMessageWithProductCode(this.needsAttentionModel?.messageInput, ProductCode.LOC);
  }

  private dispatchOtherFinancingDetails(loan: LoanData, identityVerificationAction: IdentityVerificationAction): void {
    this.actions.otherFinancingDetails({
      entityId: this.entity.id,
      loanId: loan.id,
      loanStatus: loan.customerFacingStatus,
      identityVerificationAction,
      isNPLLoan: loan.isNPLLoan
    });
  }

  onDraw(loan: LoanData): void {
    this.actions.draw({
      entityId: this.entity.id, loanId: loan.id, needsAttentionModel: {
        ...this.needsAttentionModel, messageInput: {
          ...this.needsAttentionModel.messageInput, productName: ProductCodeLabel.get(loan.productCode)
        }
      }
    });
  }

  onPay(loan: LoanData): void {
    this.actions.pay({ entityId: this.entity.id, loanId: loan.id });
  }
}
